import { formControlLabelClasses } from '@mui/material';
import { colorPalette } from '../../colorPalette';
export const formControlLabelStyles = {
    margin: 0,
    [`& .${formControlLabelClasses.label}`]: {
        color: colorPalette.gray900,
        lineHeight: '1.2621',
        marginLeft: '12px',
    },
    [`&.${formControlLabelClasses.labelPlacementStart}`]: {
        [`& .${formControlLabelClasses.label}`]: {
            marginLeft: 0,
            marginRight: '12px',
        },
    },
};
